import { APP_TYPE, envVars } from '@/config';
import { useAppDispatch, useAppSelector } from '@/store';
import { changeIdle } from '@/store/actions';
import { useGetConfigQuery, useGetScreenSaverQuery } from '@/store/global/api';
import { useIdleTimer } from 'react-idle-timer/legacy';

export const useIdle = () => {
  const { isLoading } = useGetConfigQuery({ app: APP_TYPE.HALL });
  const { data } = useGetScreenSaverQuery({ app: APP_TYPE.HALL });
  const dispatch = useAppDispatch();
  const isIdle = useAppSelector((s) => s.global.isIdle);
  const globalLoading = useAppSelector((s) => s.global.globalLoading);

  const DEFAULT_IDLE_TIMEOUT = 180;

  const onIdle = () => {
    if (data?.settings?.activate_screensaver) {
      dispatch(changeIdle(true));
    }
  };

  const { reset } = useIdleTimer({
    timeout: (data?.settings?.time_until_screensaver ?? DEFAULT_IDLE_TIMEOUT) * 1000,
    throttle: 500,
    disabled: !data?.settings?.activate_screensaver || envVars.underMaintenance || globalLoading || isLoading,
    onIdle,
  });

  const onReset = () => {
    if (data?.settings?.activate_screensaver) {
      dispatch(changeIdle(false));
      reset();
    }
  };

  return {
    onReset,
    globalLoading,
    isIdle: data?.settings?.activate_screensaver ? isIdle : false,
  };
};
